import { Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useMemo } from 'react';
import { useAppSelector } from '../../../store';
import MyTableBoldCell from '../../../components/material-ui/adaptive/MyTableBoldCell';
import { useTranslation } from 'react-i18next';
import CusTooltip from '../../../components/material-ui/CusTooltip';
import CurrencyValue from '../../../components/material-ui/CurrencyValue';
import ShowContainer from '../../../components/material-ui/ShowContainer';

export default function TotalTable() {
  const { t } = useTranslation();
  const totalInfo = useAppSelector((state) => state.reports.gamers.total);
  const currency = useAppSelector((state) => state.reports.gamers.payload.currency);

  const ValueWitchCurrency = ({ value }) => (
    <CurrencyValue
      justifyContent={'end'}
      value={value}
      currency={currency}
      fontSize={12}
      fontWeight={700}
    />
  );

  const averageBet = useMemo(() => {
    if (!totalInfo.gameSpinCount) return 0;
    return totalInfo.gameBetAmount / totalInfo.gameSpinCount;
  }, [totalInfo.gameSpinCount, totalInfo.gameBetAmount]);

  const RTPGame = useMemo(() => {
    if (!totalInfo.gameBetAmount) return 0;
    return ((totalInfo.gameWinAmount / totalInfo.gameBetAmount) * 100).toFixed(2);
  }, [totalInfo.gameWinAmount, totalInfo.gameBetAmount]);

  const totalDeposits = totalInfo.firstDepositAmount + totalInfo.repeatDepositAmount;

  return (
    <ShowContainer condition={Object.keys(totalInfo).length}>
      <Stack>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <MyTableBoldCell isLess> </MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Amount of the first deposit')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Amount of repeat deposits')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Amount of bonuses issued')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Amount of wagered bonuses')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Sum of all deposits')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Sum of all payments')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Sum of all bets')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Number of spins')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Average bet cost')}</MyTableBoldCell>
                <MyTableBoldCell isLess>{t('Player RTP')}</MyTableBoldCell>
                <MyTableBoldCell isLess>
                  <CusTooltip text={'GGR = sum of all deposits - sum of all payments'} />{' '}
                  {t('GGR')}{' '}
                </MyTableBoldCell>
                <MyTableBoldCell isLess>
                  <CusTooltip
                    text={
                      'NGR = total deposits - gateway deposit fee - player withdrawal amount - gateway withdrawal fee - game rental cost'
                    }
                  />
                  {t('NGR')}
                </MyTableBoldCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <MyTableBoldCell sx={{ px: 1 }} type="text">
                  <Stack direction={'row'} alignItems={'center'} gap={1}>
                    {t('Total')} <CusTooltip text={'Shows overall results for all pages.'} />
                  </Stack>
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalInfo.firstDepositAmount} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalInfo.repeatDepositAmount} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalInfo.issuedBonusAmount} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalInfo.wageredBonusAmount} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalDeposits} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalInfo.payoutAmount} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={totalInfo.gameBetAmount} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  {totalInfo.gameSpinCount}
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  <ValueWitchCurrency value={averageBet} />
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  {RTPGame}%
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  {totalInfo.GGR}
                </MyTableBoldCell>
                <MyTableBoldCell isLess type="numeric">
                  {totalInfo.NGR}
                </MyTableBoldCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </ShowContainer>
  );
}
